import React from "react";
import { Edit, TextInput, SimpleForm, required } from "react-admin";
import FormContainer from "../common/FormContainer";
import useUpdateWithValidation from "../common/useUpdateWithValidation";

const CustomerEdit = () => {
  const save = useUpdateWithValidation("Customer");

  return (
    <Edit>
      <SimpleForm onSubmit={save}>
        <FormContainer>
          <TextInput source="name" validate={required()} fullWidth />
          <TextInput source="contactPerson" fullWidth />
          <TextInput source="crmId" />
        </FormContainer>
      </SimpleForm>
    </Edit>
  );
};

export default CustomerEdit;
